import React from 'react';
import { withRouter } from 'react-router-dom';
import MediaQuery from 'react-responsive/src/Component';
import RecommendedMobileCarousel from 'components/organisms/recommendedMobileCarousel';
import JoinOurTeam from 'components/organisms/joinOurTeam';
import { RouteNames } from 'router';
import { RouteUtil } from 'utils/RouteUtil';
import './styles.scss';

const JoinOurTeamSection = props => {
  const { breadcrumbList } = props;
  const jobs = props.data.jobPosts;
  const toggleData = props.location.pathname !== RouteNames.about;

  const onCardClick = urlSlug => {
    const locationPath = props.location;
    RouteUtil.setRouteChange(
      props,
      `/careers/${urlSlug}`,
      locationPath.hash,
      locationPath.pathname
    );
  };
  return (
    <div>
      <MediaQuery maxDeviceWidth={575.6}>
        <RecommendedMobileCarousel
          recommendedList={jobs}
          fetchTitle={
            <div className={'text-container'}>
              <h2 className={'section-heading'}>Join Our Team</h2>
              <h4 className={'short-description'}>
                Lorem Ipsum is a dummy text used as a placeholder, mostly for
                developing a website.
              </h4>
            </div>
          }
          isDisplayLocationIcon={false}
          displayDistance={true}
          displayFullArea={true}
          isDefinedRoute={true}
          onClick={data => onCardClick(data.urlSlug)}
          breadcrumbList={breadcrumbList}
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <JoinOurTeam data={props} />
      </MediaQuery>
    </div>
  );
};

export default withRouter(JoinOurTeamSection);
